import { GoogleClassroomMemberMode, GoogleClassroomNaming } from "../../../../../../models/CoreGoogleClassroomModels";


export const GoogleClassroomMemberModeOptions: GoogleClassroomMemberMode[] = [
    GoogleClassroomMemberMode.Strict,
    GoogleClassroomMemberMode.Permissive
]

export const GoogleClassroomNamingOptions: GoogleClassroomNaming[] = [
    GoogleClassroomNaming.ActivityName,
    GoogleClassroomNaming.ActivitySchoolName,
    GoogleClassroomNaming.ActivitySchoolShortNameWithFallbackToSchoolName
]
